import { base64EncodeUnicode } from "@lib/sharedUtils";
import { Category } from "@lib/shared/types";
import { DomainInfo } from "src/api/domainInfo";
import { DomainForm } from "src/api/domainForm";
import { FieldData, Operation } from "../types";

export interface BuildThankYouUrlArgs {
    domain: DomainInfo;
    category: Category | null | undefined;
    locale: string;
    defaultLocale?: string | null;
    operation: Operation | null | undefined;
    form: DomainForm | undefined;
    fieldsData: { [k: string]: FieldData };
    ignoreCategoryInThankYouPagePath: boolean;
    queryString: string;
    params: Record<string, string>;
    leadUuid?: string;
}

/**
 * Build the absolute URL to redirect the user to the thank-you page.
 *
 * Pure modulo `window.location.origin`. Extracted from formNew.tsx so the URL
 * shape can be unit-tested without mounting the form.
 */
export function buildThankYouUrl({
    domain,
    category,
    locale,
    defaultLocale,
    operation,
    form,
    fieldsData,
    ignoreCategoryInThankYouPagePath,
    queryString,
    params,
    leadUuid,
}: BuildThankYouUrlArgs): string {
    const isSingleCategory = domain?.categories?.length === 1;
    const categorySlug = category ? `${category.slug}/` : "";
    const activeLang = locale === (defaultLocale ?? "en") ? "" : `${locale}/`;
    const winnerBuyer =
        operation?.winnerBuyer?.map((item) => item?.buyerId)?.join(",") ?? "";

    const selectedCategory = domain.categories.find(
        (categoryElement) => categoryElement.slug === form?.categorySlug,
    );
    const isSecondServiceSupported = !!(
        selectedCategory && selectedCategory?.secondServiceCategories?.length
    );

    const encodedData = base64EncodeUnicode(JSON.stringify(params));
    const zc = fieldsData["zipCode"]?.value ?? "";
    const ebPart = winnerBuyer.length > 0 ? `&eb=${winnerBuyer}` : "";
    const leadPart = leadUuid ? `&lead_uuid=${leadUuid}` : "";

    if (
        isSingleCategory ||
        isSecondServiceSupported ||
        ignoreCategoryInThankYouPagePath
    ) {
        return `${window.location.origin}/${activeLang}thank-you?data=${encodedData}&zc=${zc}${ebPart}${leadPart}&${queryString}`;
    }
    return `${window.location.origin}/${activeLang}${categorySlug}thank-you?data=${encodedData}&zc=${zc}${ebPart}${leadPart}&${queryString}`;
}
